import React from "react";
import { useNavigate } from "react-router";
import { Form, notification } from "antd";
import { useLoginMutation } from "../../../state/agencyApi";
import { LookupRequest } from "../../../models/lookup-request";
import { buildAgencyRequest } from "../../../state/connect-api";

const useLogin = () => {
  const [loginForm] = Form.useForm();
  const navigate = useNavigate();
  const [loginAPI, { isLoading }] = useLoginMutation();

  const handleLoginClick = async () => {
    const formValues = await loginForm.validateFields();
    const lookupRequest: LookupRequest = buildAgencyRequest(formValues.USERNAME, "", formValues.PASSWORD);
    const results = await loginAPI(lookupRequest).unwrap();
    if (results.ERROR[0].ERROR) {
      notification.error({ message: results.ERROR[0].ERROR });
    } else {
      notification.success({ message: "Logged in successfully" });
      localStorage.setItem("LoginId", `${results.MAIN[0].LOGIN}`);
      localStorage.setItem("LOGINTYPE", `${results.MAIN[0].LOGINTYPE}`);
      document.cookie = `isLoggedIn=1;expires=${new Date(new Date().getTime() + 24 * 60 * 60 * 1000)};path=/`;
      navigate("/home");
    }
  };

  const handleOnCancelClick = () => navigate("/");

  return {
    loginForm,
    isLoginLoading: isLoading,
    handleLoginClick,
    handleOnCancelClick
  };
};

export default useLogin;
